/**
 * Logs Core Web Vitals in development; ready to forward to analytics in production.
 * @param {import('web-vitals').Metric} metric
 */
export function logWebVitals(metric) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.info(`[Web Vitals] ${metric.name}`, Math.round(metric.value), metric);
    return;
  }

  // Hook for production analytics (GA4, Datadog RUM, etc.)
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: "web_vitals",
      metric_name: metric.name,
      metric_value: metric.value,
      metric_id: metric.id,
      metric_delta: metric.delta,
    });
  }
}
